import React from 'react';
import { FiLink2 } from 'react-icons/fi';
import { IoCodeSlashOutline, IoEyeOutline } from 'react-icons/io5';
import { MdOutlineRestore } from 'react-icons/md';
import {
  ContextMenuItem,
  ContextMenuWrapper,
} from '@/features/ai-agents/components/context-menu';

export function AgentMessageWidgetContextMenu() {
  return (
    <ContextMenuWrapper>
      <ContextMenuItem>
        <span>Copy Message Link</span>
        <FiLink2 size={18} />
      </ContextMenuItem>
      <ContextMenuItem>
        <span>Preview</span>
        <IoEyeOutline size={18} />
      </ContextMenuItem>
      <ContextMenuItem>
        <span>Edit Code</span>
        <IoCodeSlashOutline size={18} />
      </ContextMenuItem>
      <ContextMenuItem>
        <span>Restore</span>
        <MdOutlineRestore size={18} />
      </ContextMenuItem>
    </ContextMenuWrapper>
  );
}
